import { SubmissionError } from 'redux-form';
import { toast } from 'components';
import i18n from 'i18n';
import fetch from '../../utils/fetch';

export function error(error) {
  return {
    type: 'RECOVERY_NOTICE_CREATE_ERROR', error,
  };
}

export function loading(loading) {
  return {
    type: 'RECOVERY_NOTICE_CREATE_LOADING', loading,
  };
}

export function success(created) {
  return {
    type: 'RECOVERY_NOTICE_CREATE_SUCCESS', created,
  };
}

export function create(values) {
  return (dispatch) => {
    dispatch(loading(true));

    return fetch('/recovery_notices', {
      method: 'POST', body: JSON.stringify(values),
    })
      .then((response) => {
        dispatch(loading(false));

        return response.json();
      })
      .then((data) => {
        toast.success(i18n.t('recoveryCreateSuccess'));
        dispatch(success(data));
      })
      .catch((e) => {
        dispatch(loading(false));
        toast.error(i18n.t('toastError'));
        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      });
  };
}
